/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AcademicUser,
    AcademicUserFromJSON,
    AcademicUserFromJSONTyped,
    AcademicUserToJSON,
} from './AcademicUser';
import {
    Subject,
    SubjectFromJSON,
    SubjectFromJSONTyped,
    SubjectToJSON,
} from './Subject';

/**
 * 
 * @export
 * @interface CourseCoordinator
 */
export interface CourseCoordinator {
    /**
     * 
     * @type {string}
     * @memberof CourseCoordinator
     */
    subjectId?: string;
    /**
     * 
     * @type {string}
     * @memberof CourseCoordinator
     */
    academicUserId?: string;
    /**
     * 
     * @type {Date}
     * @memberof CourseCoordinator
     */
    createdAt?: Date;
    /**
     * 
     * @type {Subject}
     * @memberof CourseCoordinator
     */
    subject?: Subject;
    /**
     * 
     * @type {AcademicUser}
     * @memberof CourseCoordinator
     */
    academicUser?: AcademicUser;
}

export function CourseCoordinatorFromJSON(json: any): CourseCoordinator {
    return CourseCoordinatorFromJSONTyped(json, false);
}

export function CourseCoordinatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourseCoordinator {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subjectId': !exists(json, 'subjectId') ? undefined : json['subjectId'],
        'academicUserId': !exists(json, 'academicUserId') ? undefined : json['academicUserId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'subject': !exists(json, 'subject') ? undefined : SubjectFromJSON(json['subject']),
        'academicUser': !exists(json, 'academicUser') ? undefined : AcademicUserFromJSON(json['academicUser']),
    };
}

export function CourseCoordinatorToJSON(value?: CourseCoordinator | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subjectId': value.subjectId,
        'academicUserId': value.academicUserId,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'subject': SubjectToJSON(value.subject),
        'academicUser': AcademicUserToJSON(value.academicUser),
    };
}

